export const getIsGetting = state => state.getIn(['plan', 'isGetting']);
export const getIsPosting = state => state.getIn(['plan', 'isPosting']);
export const getErrMsg = state => state.getIn(['plan', 'errMsg']);


export const getStorage = state => state.getIn(['plan', 'storage']);
export const getPlan = state => state.getIn(['plan', 'plan']);
export const getExpire = state => state.getIn(['plan', 'expire']);
export const getUpgradeList = state => state.getIn(['plan', 'upgradeList']);